var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GradientBarComponent',{attrs:{"labels":[
    '0.0',
    '0.6',
    '3.0',
    '6.5',
    '11.0',
    '16.0',
    '21.0',
    '27.0',
    '33.0',
    '40.0',
    '48.0',
    '55.0',
    '63.0',
  ],"gradientColors":[
    '#003366',
    '#005c99',
    '#0080cc',
    '#00a3e6',
    '#33bbff',
    '#66d1ff',
    '#99e0ff',
    '#ffd699',
    '#ffcc66',
    '#ffb34d',
    '#ff8c1a',
    '#ff5c33',
    '#e60000',
  ],"unit":"knots"}})
}
var staticRenderFns = []

export { render, staticRenderFns }